export function resolvePurchaseRevenueCatUserId(
  revenueCatId: string | null | undefined,
) {
  const trimmedId = revenueCatId?.trim() ?? ''
  return trimmedId.length > 0 ? trimmedId : null
}
